import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  mainContainer: {
    background: "#F5F8FF",
    minHeight: "100%",
    width: "100%",
    position: "absolute",
    bottom: "auto",
  },
  root: {
    padding: "20px 20px 0px 20px",
    marginTop: "40px",
  },
  tableDiv: {
    border: "1px",
  },
  filterBox: {
    display: "flex",
    justifyContent: "space-between",
    width: 500,
    gap: 20,
  },
  filterSelect: {
    width: 300,
  },
  clearFilter: {
    color: "#EDAC15",
    fontSize: 14,
    fontWeight: 400,
    cursor: "pointer",
  },
  dateDiv: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  dateDivRoot: {
    marginTop: 50,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  page: {
    position: "relative",
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 50,
    marginBottom: 24,
  },
  ml25: {
    marginLeft: "25px !important",
  },
  search: {
    background: "#F5F5F5",
    border: "none",
    borderRadius: 7,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  cell: {
    maxWidth: "300px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dataTableDiv: {
    maxHeight: "calc(100vh - 210px)",
    //maxWidth: "calc(159vh)",
    border: "1px solid #C6C9CA",
    overflowY: "auto",
    overflowX: "auto",
    marginTop: "0px",
    background: "#F5F8FF",
  },
  addBtn: {
    fontSize: 14,
    color: "#333333",
    border: "1px solid #D5D8DE",
    fontFamily: "Cairo",
    fontWeight: "400",
  },
  btnDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  datePicker1: {
    position: "absolute",
    opacity: 0,
    zIndex: -1,
    right: "200px",
  },
  datePicker: {
    position: "absolute",
    opacity: 0,
    zIndex: -1,
  },
  dateButton: {
    color: "#333333",
    border: "1px solid #D5D8DE",
    backgroundColor: "#F7F7FA",
    minWidth: "180px",
    fontSize: "14px",
    minHeight: "45px",
  },
  addModal: {
    position: "absolute",
    background: "#FFFFFF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "730px",
    height: "463px",
  },
  modalContainer: {
    padding: "20px",
  },
  headerModal: {
    color: "#012497",
    fontFamily: "Cairo",
    fontWeight: "800",
    fontSize: "24px",
  },
  deleteTypo: {
    color: "#2A3333",
    fontFamily: "Cairo",
    fontWeight: "400",
    fontSize: "16px",
  },
  btnContainer: {
    display: "flex",
    alignItems: "center",
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": {
      borderColor: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  label: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "16px",
    color: "#2A3333",
  },
  Textfield: {
    width: "220px",
    maginTop: "10px",
  },
  textEnabled: {
    background: "#FFF",
    marginTop: "6px",
  },
}));
